import { createSlice } from "@reduxjs/toolkit";

interface PickEstablishmentModalInterface {
    isPickEstablishmentModalOpen: boolean;
    searchTerm: string;
}

const initialState: PickEstablishmentModalInterface = {
    isPickEstablishmentModalOpen: false,
    searchTerm: "",
};

const pickEstablishmentModalSlice = createSlice({
    name: "pickEstablishmentModal",
    initialState,
    reducers: {
        setIsPickEstablishmentModalOpen: (state, action) => {
            state.isPickEstablishmentModalOpen = action.payload;
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
    },
});

export const pickEstablishmentModalReducer =
    pickEstablishmentModalSlice.reducer;

export const { setIsPickEstablishmentModalOpen, setSearchTerm } =
    pickEstablishmentModalSlice.actions;
